import styled from '@emotion/styled'

export const MfaOptionBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 5px;
`
